import L from "leaflet";

L.Map.CustomSelectArea = L.Map.SelectArea.extend({
      initialize: function (map, options) {
      L.Util.setOptions(this, options || {});
      L.Map.BoxZoom.prototype.initialize.call(this, map);

      // Bind methods to the instance to maintain the correct context
      this.rectangleDown = this.rectangleDown.bind(this);
      this.cornerDown = this.cornerDown.bind(this);
      this.rectangleMove = this.rectangleMove.bind(this);
      this.cornerMove = this.cornerMove.bind(this);
      this.mouseUp = this.mouseUp.bind(this);

      //Add event listeners for mouse and touch events
      L.DomEvent.on(document, 'mouseup', this.mouseUp, this)
      L.DomEvent.on(document, 'touchend', this.mouseUp, this)

      this._map.on("mousemove", this.mouseMove, this)
      this._map.getContainer().addEventListener("touchmove", (e) => {
        let latlng = this.getTouchedLatLng(e)
        this.touchMove(e, latlng)
      })
      this._map.getContainer().addEventListener("touchstart", (e) => {
        let latlng = this.getTouchedLatLng(e)
        this.touchStart(latlng)
      })

      this._corners = [];
      this._antimeridianCorners = [];
      this._prevMousePosition = null;
      this._cornerPressed = false;
      this._clickedCorner = null;
      this._rectanglePressed = false;
      this._rectangle = null;
      this._antimeridianRectangle = null;
      this._suppressEvents = false;
    },

    /**
     * @param {Array} corners
     */
    setCorners: function (corners) {
      this._corners = corners;
    },

    /**
     * @param {Array} corners
     */
    setAntimeridianCorners: function (corners) {
      this._antimeridianCorners = corners;
    },

    /**
     * @param {L.LatLng} prevMousePosition
     */
    setPrevMousePosition: function (prevMousePosition) {
      this._prevMousePosition = prevMousePosition;
    },

    /**
     * @param {Boolean} rectanglePressed
     */
    setRectanglePressed: function (rectanglePressed) {
      this._rectanglePressed = rectanglePressed;
    },

    /**
     * @param {Boolean} cornerPressed
     */
    setCornerPressed: function (cornerPressed) {
      this._cornerPressed = cornerPressed;
    },

    /**
     * @param {L.rectangle} newRectangle
     */
    setRectangle: function (newRectangle) {
      this._rectangle = newRectangle;
    },

    /**
     * @param {L.rectangle} newRectangle
     */
    setAntimeridianRectangle: function (newRectangle) {
      this._antimeridianRectangle = newRectangle;
    },

    /**
     * @param {L.circleMarker} clickedCorner
     */
    setClickedCorner: function (clickedCorner) {
      this._clickedCorner = clickedCorner;
    },

    
    /**
     * Changes the bounds/locations of the rectangles and circles on the map to the supplied bounds.
     */
    updateArea: function(newBounds){
      this._rectangle.setBounds(newBounds)
      this._corners[0].setLatLng(newBounds.getNorthWest());
      this._corners[1].setLatLng(newBounds.getNorthEast());
      this._corners[2].setLatLng(newBounds.getSouthWest());
      this._corners[3].setLatLng(newBounds.getSouthEast());


      let antimeridianBounds = L.latLngBounds(
        L.latLng(newBounds.getSouthWest().lat, newBounds.getSouthWest().lng + 360),
        L.latLng(newBounds.getNorthEast().lat, newBounds.getNorthEast().lng + 360)
      );

      this._antimeridianRectangle.setBounds(antimeridianBounds)
      // Draw corners for the antimeridian rectangle.
      this._antimeridianCorners.forEach((corner, i) => {
        let adjustedCorner = L.latLng(this._corners[i].getLatLng().lat, this._corners[i].getLatLng().lng + 360);
        corner.setLatLng(adjustedCorner)
      })

      let map = this._map
      let wrappedBounds = this.wrappedBounds(newBounds)
      
      if (!this._suppressEvents) {
        L.Util.requestAnimFrame(function () {
          let eventName = "areaselectstart";
          try {
            if (L.Map && L.Map.SelectArea && L.Map.SelectArea.AREA_SELECT_START && typeof L.Map.SelectArea.AREA_SELECT_START === 'string') {
              eventName = L.Map.SelectArea.AREA_SELECT_START;
            }
          } catch (e) {
            // Fallback to default event name
          }
          map.fire(eventName, {
            bounds: wrappedBounds
          });
        });
      }
    },

    /**
     * Draws the initial rectangles and circles for the selected area. Will draw one rectangle and four circles in the center of
     * the visible area, and also on the opposite side to handle antimeridian/worldcopyjump rendering issues.
     */
    drawArea: function (existingBounds){
      let map = this._map
      let bounds = existingBounds

      if(!bounds){
        bounds = this._map.getBounds().pad(-0.25);
      }

      // Remove existing shapes
      this._map.eachLayer((layer) => {
        if (layer instanceof L.Rectangle || layer instanceof L.Polyline || layer instanceof L.CircleMarker) {
          this._map.removeLayer(layer);
        }
      });

      // Creates a new rectangle
      const newRectangle = L.rectangle(bounds, {
        color: "blue",
        weight: 1,
      }).addTo(this._map);

      newRectangle.on("mousedown", this.rectangleDown)

      this.setRectangle(newRectangle)

      // Draw points at rectangle corners
      const corners = [bounds.getNorthWest(), bounds.getNorthEast(), bounds.getSouthWest(), bounds.getSouthEast()];
      this.setCorners([])

      corners.forEach(corner => {
        let boxCorner = L.circleMarker(corner, {
          color: "blue",
          fillOpacity: 1,
          radius: 8,
        }).addTo(this._map)

        boxCorner.on("mousedown", this.cornerDown)
        this._corners.push(boxCorner);
        this.setCorners(this._corners);
      })

      let wrappedBounds = this.wrappedBounds(bounds)
      L.Util.requestAnimFrame(function () {
        let eventName = "areaselectstart";
        try {
          if (L.Map && L.Map.SelectArea && L.Map.SelectArea.AREA_SELECT_START && typeof L.Map.SelectArea.AREA_SELECT_START === 'string') {
            eventName = L.Map.SelectArea.AREA_SELECT_START;
          }
        } catch (e) {
          // Fallback to default event name
        }
        map.fire(eventName, {
          bounds: wrappedBounds
        });
      });


      // Draw another rectangle at +360 longitude to help with antimeridian rendering
      let antimeridianBounds = L.latLngBounds(
        L.latLng(bounds.getSouthWest().lat, bounds.getSouthWest().lng + 360),
        L.latLng(bounds.getNorthEast().lat, bounds.getNorthEast().lng + 360)
      );

      const antimeridianRectangle = L.rectangle(antimeridianBounds, {
        color: "blue",
        weight: 1,
      }).addTo(this._map);

      this.setAntimeridianRectangle(antimeridianRectangle);

      antimeridianRectangle.on("mousedown", this.rectangleDown)

      // Draw corners for the antimeridian rectangle.
      this.setAntimeridianCorners([])

      corners.forEach(corner => {
        let antimeridianLatLng = L.latLng(corner.lat, corner.lng + 360);
        let antimeridianCorner = L.circleMarker(antimeridianLatLng, {
          color: "blue",
          fillOpacity: 1,
          radius: 8,
          bubblingMouseEvents: false,
        }).addTo(this._map)

        antimeridianCorner.on("mousedown", this.cornerDown)
        this._antimeridianCorners.push(antimeridianCorner);
        this.setAntimeridianCorners(this._antimeridianCorners);
      })
    },

    cornerDown: function(e){
      // Prevent corner interaction if selection is disabled
      if(!this._cornerPressed && this._map.customSelectArea && this._map.customSelectArea._allowInteraction !== false){
        let container = this._map.getContainer();
        let relativeX = e.originalEvent.clientX - container.getBoundingClientRect().left;
        let relativeY = e.originalEvent.clientY - container.getBoundingClientRect().top;
        let actualPoint = L.point(relativeX, relativeY)

        this.setClickedCorner(e.sourceTarget);

        this.setPrevMousePosition(actualPoint)
        this._map.dragging.disable();
        this.setCornerPressed(true);
        this.setRectanglePressed(false);
        L.DomUtil.disableTextSelection();
        L.DomUtil.disableImageDrag();
      }
    },

    /**
     * Will determine which corner is to be moved, and calculates the correct changes to the retangle bounds before calling 
     * updateArea.
     */
    cornerMove: function(e){
      if(e.originalEvent.buttons === 1 && this._prevMousePosition?.x){
        //Get the latlng object of the corner
        let cornerLatLng = e.sourceTarget.getLatLng();

        //Get the latlng objects for all corners
        let northEast = this._rectangle.getBounds().getNorthEast();
        let southWest = this._rectangle.getBounds().getSouthWest();
        let northWest = L.latLng(northEast.lat, southWest.lng);
        let southEast = L.latLng(southWest.lat, northEast.lng);

        //Get all the container points using the latlng objects
        let northEastContainerPoint = this._map.latLngToContainerPoint(northEast);
        let southWestContainerPoint = this._map.latLngToContainerPoint(southWest);

        //convert the previous and current lat/lngs to container points.
        let prevContainerPoint = this._prevMousePosition;
        let container = this._map.getContainer();
        let relativeX = e.originalEvent.clientX - container.getBoundingClientRect().left;
        let relativeY = e.originalEvent.clientY - container.getBoundingClientRect().top;
        let currentContainerPoint = L.point(relativeX, relativeY)

        //calculate the x and y difference from the previous and current points
        let xDifference = prevContainerPoint.x - currentContainerPoint.x;
        let yDifference = prevContainerPoint.y - currentContainerPoint.y;

        //Determine which corner is moving and perform the correct changes to the bounds.
        if((cornerLatLng.lat === northWest.lat && cornerLatLng.lng === northWest.lng) || 
        (cornerLatLng.lat === northWest.lat && cornerLatLng.lng === northWest.lng + 360)){
          //change the y axis of the north east point and the x axis of the south west point to change the north west point
          northEast = this._map.containerPointToLatLng(L.point(
            northEastContainerPoint.x,
            northEastContainerPoint.y - yDifference
          ));
          southWest = this._map.containerPointToLatLng(L.point(
            southWestContainerPoint.x - xDifference,
            southWestContainerPoint.y
          ));
        }
        else if((cornerLatLng.lat === northEast.lat && cornerLatLng.lng === northEast.lng) || 
        (cornerLatLng.lat === northEast.lat && cornerLatLng.lng === northEast.lng + 360)){
          //change the north eastern point
          northEast = this._map.containerPointToLatLng(L.point(
            northEastContainerPoint.x - xDifference,
            northEastContainerPoint.y - yDifference
          ));
        }
        else if((cornerLatLng.lat === southEast.lat && cornerLatLng.lng === southEast.lng) || 
        (cornerLatLng.lat === southEast.lat && cornerLatLng.lng === southEast.lng + 360)){
          //change the x axis of the north east point and the y axis of the south west point to change the south east point
          northEast = this._map.containerPointToLatLng(L.point(
            northEastContainerPoint.x - xDifference,
            northEastContainerPoint.y
          ));
          southWest = this._map.containerPointToLatLng(L.point(
            southWestContainerPoint.x,
            southWestContainerPoint.y - yDifference
          ));
        }
        else if((cornerLatLng.lat === southWest.lat && cornerLatLng.lng === southWest.lng) || 
        (cornerLatLng.lat === southWest.lat && cornerLatLng.lng === southWest.lng + 360)){
          //change the south western point
          southWest = this._map.containerPointToLatLng(L.point(
            southWestContainerPoint.x - xDifference,
            southWestContainerPoint.y - yDifference
          ));
        }

        // Create new bounds with adjusted lat/lng
        let newBounds = L.latLngBounds(northEast, southWest);

        // Update previous mouse position
        this.setPrevMousePosition(currentContainerPoint);

        // Draw the updated rectangle
        this.updateArea(newBounds);

        this._map.dragging.enable();
      }
    },

    rectangleDown: function(e){
      // Prevent rectangle interaction if selection is disabled
      if(!this._rectanglePressed && this._map.customSelectArea && this._map.customSelectArea._allowInteraction !== false){
        this.setPrevMousePosition(e.latlng)
        this._map.dragging.disable();
        this.setCornerPressed(false);
        this.setRectanglePressed(true);
        L.DomUtil.disableTextSelection();
        L.DomUtil.disableImageDrag();
      }
    },

    /**
     * Will move the drawn rectangle when clicking and dragging it. This is done by using the new and old positions of the mouse
     * to calculate the distance and direction the rectangle needs to move. The rectangle is then removed and re-drawn at the
     * new location.
     */
    rectangleMove: function(e){
      //only move rectangle if left click is held down
      if(e.originalEvent.buttons === 1 && this._prevMousePosition?.lat){
        this._map.dragging.disable();

        //convert the previous and current lat/lngs to container points.
        let prevContainerPoint = this._map.latLngToContainerPoint(this._prevMousePosition);
        let currentContainerPoint = this._map.latLngToContainerPoint(e.latlng);

        //calculate the x and y difference from the previous and current points
        let xDifference = prevContainerPoint.x - currentContainerPoint.x;
        let yDifference = prevContainerPoint.y - currentContainerPoint.y;

        //get the northEast and southWest container points from the rectangle
        let northEastContainerPoint = this._map.latLngToContainerPoint(this._rectangle.getBounds().getNorthEast());
        let southWestContainerPoint = this._map.latLngToContainerPoint(this._rectangle.getBounds().getSouthWest());

        //create new lat/lng points for the rectangle by subtracting the difference
        let newNorthEast = this._map.containerPointToLatLng(L.point(
          northEastContainerPoint.x - xDifference,
          northEastContainerPoint.y - yDifference
        ));
        let newSouthWest = this._map.containerPointToLatLng(L.point(
          southWestContainerPoint.x - xDifference,
          southWestContainerPoint.y - yDifference
        ));

        // Create new bounds with adjusted lat/lng
        let newBounds = L.latLngBounds(newNorthEast, newSouthWest);

        // Update previous mouse position
        this.setPrevMousePosition(e.latlng);

        // Draw the updated rectangle
        this.updateArea(newBounds);

        this._map.dragging.enable();
      }
    },

    mouseUp: function(e){
      if(this._rectanglePressed || this._cornerPressed){
        this._map.dragging.enable();
        let map = this._map
        let bounds = this.wrappedBounds(this._rectangle.getBounds())
        this.setRectanglePressed(false);
        this.setCornerPressed(false);
        L.DomUtil.enableTextSelection();
        L.DomUtil.enableImageDrag();


        L.Util.requestAnimFrame(function () {
          let eventName = "areaselected";
          try {
            if (L.Map && L.Map.SelectArea && L.Map.SelectArea.AREA_SELECTED && typeof L.Map.SelectArea.AREA_SELECTED === 'string') {
              eventName = L.Map.SelectArea.AREA_SELECTED;
            }
          } catch (e) {
            // Fallback to default event name
          }
          map.fire(eventName, {
            bounds: bounds
          });
        });
      }
    },

    /**
     * Will call either the cornerDown or rectangleDown functions based on which was touched.
     */
    touchStart: function(e){
      let latlng = L.latLng(e.lat, e.lng);
      let cornerClicked = false;
      let corners = [...this?._corners, ...this?._antimeridianCorners];

      // Check if the LatLng object is touching any corners

      corners.forEach(corner => {
        // Calculate the distance between the touch point and the center of the circle
        let touchPoint = this._map.latLngToContainerPoint(latlng);
        let cornerPoint = this._map.latLngToContainerPoint(corner.getLatLng());
        
        let distance = Math.sqrt(
          Math.pow(touchPoint.x - cornerPoint.x, 2) +
          Math.pow(touchPoint.y - cornerPoint.y, 2)
        );

        if(distance <= corner.getRadius()){
          let container = this._map.getContainer();
          cornerClicked = true;
          this.cornerDown({
            sourceTarget: corner,
            originalEvent: 
            {
              clientX: touchPoint.x + container.getBoundingClientRect().left,
              clientY: touchPoint.y + container.getBoundingClientRect().top
            }
          });
          return;
        }
      })

      if(cornerClicked){
        return;
      }

      // Check if the LatLng object is within the bounds of the rectangle.
      if (this._rectangle?.getBounds().contains(latlng) || this._antimeridianRectangle?.getBounds().contains(latlng)) {
          this.rectangleDown({latlng: latlng});
      }
    },

    /**
     * Will call the mouseMove function and pass it the correct variables.
     */
    touchMove: function(e, latlng){
      let touchPoint = this._map.latLngToContainerPoint(latlng);
      let container = this._map.getContainer();

      this.mouseMove({
        sourceTarget: this.clickedCorner,
        originalEvent: 
        {
          buttons: 1,
          clientX: touchPoint.x + container.getBoundingClientRect().left,
          clientY: touchPoint.y + container.getBoundingClientRect().top
        },
        latlng: latlng
      });
    },

    /**
     * Calls either rectangleMove or cornerMove if left click is being held depending on which one was clicked.
     */
    mouseMove: function(e){
      if(this._rectanglePressed && e.originalEvent.buttons === 1){
        this.rectangleMove(e);
      }
      if(this._cornerPressed && e.originalEvent.buttons === 1){
        e.sourceTarget = this._clickedCorner;
        this.cornerMove(e);
      }
    },

    /**
     * Calculates the latlng coordinates of the map from the screen touch position.
     */
    getTouchedLatLng: function(e){
      let touch = e.touches[0];

      let container = this._map.getContainer();

      // Calculate the relative coordinates within the map container
      let relativeX = touch.clientX - container.getBoundingClientRect().left;
      let relativeY = touch.clientY - container.getBoundingClientRect().top;

      // Convert touch coordinates to container point
      let containerPoint = L.point(relativeX, relativeY);

      // Convert container point to LatLng coordinates
      let latlng = this._map.containerPointToLatLng(containerPoint);

      return latlng
    },

    /**
     * Resets variables to their initial values and removes any added map layers.
     */
    reset: function(){
      this._map.eachLayer((layer) => {
        if (layer instanceof L.Rectangle || layer instanceof L.CircleMarker || layer instanceof L.Polyline) {
          this._map.removeLayer(layer);
        }
      });

      this.setCorners([]);
      this.setAntimeridianCorners([]);
      this.setPrevMousePosition(null);
      this.setCornerPressed(false);
      this.setClickedCorner(null);
      this.setRectanglePressed(false);
      this.setRectangle(null);
      this.setAntimeridianRectangle(null);
    },

    /**
     * Take a given bounds variable and convert it to be within the normal range of longitudes
     */
    wrappedBounds: function(bounds){
      // Create a new LatLngBounds object based on the original bounds
      let normalizedBounds = L.latLngBounds(
        L.latLng(bounds.getSouthWest().lat, bounds.getSouthWest().lng),
        L.latLng(bounds.getNorthEast().lat, bounds.getNorthEast().lng)
      );

      // Modify the new bounds
      if (normalizedBounds._northEast.lng > 180) {
        normalizedBounds._northEast.lng = (normalizedBounds._northEast.lng + 180) % 360 - 180;
      }

      if (normalizedBounds._northEast.lng < -180) {
        normalizedBounds._northEast.lng = (normalizedBounds._northEast.lng - 180) % 360 + 180;
      }

      if (normalizedBounds._southWest.lng > 180) {
        normalizedBounds._southWest.lng = (normalizedBounds._southWest.lng + 180) % 360 - 180;
      }

      if (normalizedBounds._southWest.lng < -180) {
        normalizedBounds._southWest.lng = (normalizedBounds._southWest.lng - 180) % 360 + 180;
      }

      return normalizedBounds;
    },
})

// register hook
L.Map.addInitHook('addHandler', 'customSelectArea', L.Map.CustomSelectArea);